import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { UserAccessService } from 'src/app/service/admin/user-access.service';
declare var $: any;

@Component({
  selector: 'app-user-access-request-list',
  templateUrl: './user-access-request-list.component.html',
  styleUrls: ['./user-access-request-list.component.css']
})
export class UserAccessRequestListComponent implements OnInit {

  @BlockUI() blockUI : NgBlockUI;

  @ViewChild('confirmRejectModal') confirmRejectTemplate:TemplateRef<any>;
 confirmRejectModalRef: BsModalRef;

  @ViewChild('rejectStatusModal') rejectStatusTemplate:TemplateRef<any>;
  rejectStatusModalRef: BsModalRef;

  //tableLoader = true;

  userAccessReqList : any[] = [];

  sortOrder: String = "ASC";
  sortBy: String = "REQUEST_DATE";
  
  pageNum = 1;
  recPerPage = 10;
  totalRecords: any;
  totalPages: any;
  totalPageArray: Array<number>;

  selectedUserRequest : any
  rejectStatusMsg: string;
  rejectStatus: any;

  rejectNotes: string;
  missingNotes: string;

  constructor(private userAccessService : UserAccessService, private modalService: BsModalService, private router :Router) { }

  ngOnInit() {
    this.getUserAccessRequestList();
  }

  getUserAccessRequestList(){

    //this.tableLoader = true;

    this.blockUI.start();
    let params = {
      "pageNum": this.pageNum,
      "recPerPage": this.recPerPage,
      "sortBy": this.sortBy,
      "sortOrder": this.sortOrder
    };

    this.userAccessService.getUserAccessRequestList(params).subscribe(data => {

      if(data.status == 'S'){
        this.userAccessReqList = data.userAccessList;
        this.totalRecords = data.totalRec;

        this.totalPages = this.calTotalPages(this.totalRecords);
        this.totalPageArray = new Array(this.totalPages);

        //this.tableLoader = false;
        

      }else{
        console.log("Unable to get the list.");
      }

      this.blockUI.stop();

        

    });
  }

  setSortOrder(sortBy,sortOrder,type){
    this.sortBy = sortBy;
    this.sortOrder = sortOrder;
    
    this.getUserAccessRequestList();
  }

  calTotalPages (pages){
    let totalPages = pages/10;
    let roundedTotalPages = Math.round(totalPages);
  
    if (totalPages > roundedTotalPages) {
      totalPages = roundedTotalPages + 1;
    }else {
      totalPages = roundedTotalPages;
    }
  
    console.log('totalPages',totalPages);

    return totalPages;
  }

  setPage (i, event: any) {
    event.preventDefault();     
    this.pageNum= i;
    this.getUserAccessRequestList();
  }
  
  setNextPage (event: any) {  
    event.preventDefault(); 
    this.pageNum++;
    this.getUserAccessRequestList();
  }

  setPrevPage (event: any) {
    event.preventDefault();   
    if (this.pageNum > 1){
      this.pageNum--;
    }
    this.getUserAccessRequestList();
  }
  
  setFirstPage (event: any) {
    event.preventDefault();
   
    this.pageNum = 1;
    this.getUserAccessRequestList();
  }
  
  setLastPage (i,event: any) {
    event.preventDefault();
    this.pageNum = i;
    this.getUserAccessRequestList();
  }

  processRequest(userReq){
    const navigationExtras: NavigationExtras = {
      state: {
        recId: userReq.RECORD_ID
      }
    }
    this.router.navigate(['/accessDetails'], navigationExtras);
    //this.router.navigate(['/accessDetails'], { queryParams: { id: userReq.RECORD_ID } }); 
  }

  openConfirmReject(userReq){
    console.log('Inside openConfirmReject');
    console.log('userReq.EMAIL_ADDRESS:' + userReq.EMAIL_ADDRESS);
    this.selectedUserRequest = userReq;
    this.missingNotes = "";
    this.rejectNotes = '';

    this.confirmRejectModalRef= this.modalService.show(this.confirmRejectTemplate);
  }

  rejectRequest(){

    console.log('after rejectUserAccessRequest');

    //Check if notes is available
    if(!this.rejectNotes || (this.rejectNotes && this.rejectNotes.trim() === '')){
      this.missingNotes = "Please provide your notes for rejection."
      return;
    }

    let param = this.selectedUserRequest;

    param.NOTES = this.rejectNotes;

    this.blockUI.start();

    this.userAccessService.rejectUserAccessRequest(param).subscribe(data => {

      this.rejectStatusMsg = data.message;

      this.rejectStatus = data.status;

      /* if(data.status == 'S'){

        //Display the reject status message modal
        this.rejectStatusMsg = 'Access Request for email address - ' + this.selectedUserRequest.EMAIL_ADDRESS + ' is Rejected and email sent to the user';

      }else{
         this.rejectStatusMsg = 'Access Request for email address - ' + this.selectedUserRequest.EMAIL_ADDRESS + ' could not be processed';
      }*/  

      //close the modal
      //$('#confirm-reject-modal').modal('hide');
      this.closeModal('confirmReject');

      //reset the selectedUserRequest
      this.selectedUserRequest = {};

      this.blockUI.stop();
      
      //close the modal
      //$('#reject-status-modal').modal('show');      
      this.rejectStatusModalRef = this.modalService.show(this.rejectStatusTemplate);
        
    });

  }

  closeModal(modalType : string){
    
    if(modalType === 'rejectStatus'){

      //load the list again
      this.pageNum = 1;
      this.getUserAccessRequestList();

      this.rejectStatusModalRef.hide();
    }else if(modalType === 'confirmReject'){
      this.confirmRejectModalRef.hide();
    }
  }

}
